module.exports = __webpack_public_path__ + "img/fas-chevron-left.138e627a.svg";